export const user = {
  state: {
    userToken: '',
    roleId: '',
    userData: {}
  },
  mutations: {
    'SET_USER_TOKEN' (state , token){
      state.userToken = token
    },
    'SET_USER_DATA' (state, userData) {
      state.userData = userData
    },
    'SET_ROLE_ID' (state, roleId) {
      state.roleId = roleId
    }
  },
  actions: {
    setUserToken({commit},token){
      commit('SET_USER_TOKEN',token)
    },
    setUserData({commit}, userData) {
      commit('SET_USER_DATA', userData)
    },
    setRoleId({commit}, roleId) {
      commit('SET_ROLE_ID',roleId)
    }
  }
}
